import { getDefaultAuthConfig } from './authSettings';
import { getDefaultConnectorDraft } from './connectors';
import { getDefaultAddContextLabels } from './contextTypes';
import { getDefaultSyncSettings } from './syncSettings';

const collectionsState = {
  data: {
    title: '',
    description: '',
    contentExtractionAuthConfig: getDefaultAuthConfig(),
    labels: [],
    syncSettings: getDefaultSyncSettings(),
  },
  etc: {
    status: 'draft',
    itemCounts: {
      url: 0,
      media: 0,
      plainText: 0,
      total: 0,
      completed: 0,
      failed: 0,
      pending: 0,
    },
    entryPointCounts: {
      manual: 0,
      sitemap: 0,
      connector: 0,
    },
    items: [],
    isCreateCollectionDrawerOpen: false,
    creationType: 'create',
    collectionsStep: 0,
    isAddContextDrawerOpen: false,
    addContextStep: 0,
    selectedContextType: null,
    addContextLabels: getDefaultAddContextLabels(),
    addContextUseAsReference: true,
    urlLabelDrafts: {},
    urlUseAsReferenceDrafts: {},
    stagedMediaFiles: [],
    urlInputText: '',
    plainTextInput: '',
    sitemapUrlInput: '',
    connectorDraft: getDefaultConnectorDraft(),
    editingContextItem: null,
    typeFilter: 'all',
    statusFilter: 'all',
    selectedRowKeys: [],
    expandedRowKeys: [],
    discoveringKey: null,
    sitemapDiscoveredLinks: {},
    isFilterUrlsDrawerOpen: false,
    filterUrlsEntryPointId: null,
    filterUrlsSelected: [],
    isSyncSettingsDrawerOpen: false,
    syncSettingsDraft: null,
    isAuthSettingsDrawerOpen: false,
    authSettingsDraft: null,
    chunksDrawerItem: null,
  },
};

export default collectionsState;
